import React, { useState, useEffect } from "react";
import { connect, useSelector } from 'react-redux';
import { withRouter } from 'react-router';
import EstimatesMessage from '../estimates/estimatesMessage';
import Appointments from '../estimates/appointments';
import { logUI } from "../../api/andyliticsApi";
import ErrorMessage from "../estimates/ErrorMessage";
import Spinner from '../common/spinner';
import MessageWithIcon from '../common/MessageWithIcon';
import MyChartContainer from "../mychart/MyChartContainer";

const MyEstimates = props => {
    //const customerServicePhone = "844.211.1790";
    const { patient, currentUser, enableMyChartEstimates } = props;
    const [activeTab, setActiveTab] = useState('1');

    if (Object.keys(props.error).length > 0) console.error(`myEstimates error`, props.error);

    try {
        return enableMyChartEstimates
            ? <MyChartContainer mode="patientEstimates" title="Estimates" />
            : <React.Fragment>
                <div className={"container-fluid body-content estimate-body-container"}>
                    <div className="row">
                        <div className="col-12 maxWidth-content">
                            <div className="row">
                                <div className="col-12">
                                    <h1 className="page-heading">Estimates{patient.EID !== currentUser.eid ? <span> ({patient.PatientName.substring(0, patient.PatientName.indexOf(' '))})</span> : <React.Fragment></React.Fragment>}
                                    </h1>
                                </div>
                            </div>
                            <div className="row estimate-messaging estimate-details-tile-message">
                                <div className="col-12">
                                    <MessageWithIcon icon="icon-input-error">
                                        Are my estimates reflective of my benefits? <EstimatesMessage target="your-estimates"
                                            message="Your estimates reflect your benefits on the date the estimate was generated. Any claim activity after this estimate was generated could impact your total out-of-pocket expense. All estimates are subject to change. Your final costs will be reflected on your post-visit statement."
                                        />
                                    </MessageWithIcon>
                                </div>
                            </div>
                            <div className="row estimate-messaging estimate-details-tile-message">
                                <div className="col-12">
                                    <MessageWithIcon icon="icon-input-error">
                                        Can{`'`}t find your estimate or appointment? <EstimatesMessage preRegPhone={props.customerServicePhone} target="Not-all-appointments" message={'Not-all-appointments'} />
                                    </MessageWithIcon>
                                </div>
                            </div>
                            <div className="row estimate-tab-buttons">
                                <div className="col-12">
                                    <button type="button" className={"btn btn-primary" + (activeTab === '1' ? " active" : "")} onClick={() => setActiveTab('1')}>UPCOMING</button>
                                    <button type="button" className={"btn btn-primary" + (activeTab === '2' ? " active" : "")} onClick={() => setActiveTab('2')}>PAST</button>
                                </div>
                            </div>
                            <div className={"row estimate-tab-option" + (activeTab === '1' ? " option-active" : "")}>
                                <div className="col-12">
                                    <div className="row estimate-messaging__heading">
                                        <div className="col-12">
                                            <h2>Estimates for Upcoming Appointments</h2>
                                        </div>
                                    </div>
                                    <Appointments loaded={props.loaded} appointments={props.appointments} key={`upcoming`} past={false} />
                                </div>
                            </div>
                            <div className={"row estimate-tab-option" + (activeTab === '2' ? " option-active" : "")}>
                                <div className="col-12">
                                    <div className="row estimate-messaging__heading">
                                        <div className="col-12">
                                            <h2>Estimates for Past Appointments</h2>
                                        </div>
                                    </div>
                                    <Appointments loaded={props.loaded} appointments={props.appointments} key={`past`} past={true} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`container-fluid footer-container estimate-footer`}>
                    <div className="row">
                        <div className="col-12 maxWidth-content">
                            Contact our Pre-Registration department Monday through Friday, 8:00AM to 5:00PM : <a className="phone-link" href={"tel:" + props.customerServicePhone}>{props.customerServicePhone}</a>
                        </div>
                    </div>
                </div>
                {props.loaded ? <React.Fragment></React.Fragment> : <Spinner />}
            </React.Fragment>
    } catch (ex) {
        console.error(`myEstimates exception`, ex);
        logUI("MBHWeb.UI.Estimates.myEstimates", new Date(), `myEstimates/`, props, 'ERROR', ex.message);
        return <ErrorMessage />;
    }
};

function mapStateToProps(state) {
    return {
        customerServicePhone: state.session.serverData.pricingPreRegPhone,
        enableMyChartEstimates: state.session.serverData.enableMyChartEstimates
    };
}


export default withRouter(connect(mapStateToProps)(MyEstimates));